module.exports = __webpack_public_path__ + "img/puerto-vallarta-muelle.14e5feb1.jpg";